import * as React from "react";
import { Tag, TagType } from "../types/Tagging.types";
import { Dialog, DialogFooter, Dropdown, PrimaryButton, TextField } from "office-ui-fabric-react";

export interface INewTagDialogProps {
    tag?: Tag;
    onDismiss: () => void;
    onSubmit: (tag: Tag) => Promise<void>;
    type: TagType | undefined;
}

export const NewTagDialog = (props: INewTagDialogProps) => {

    const { tag, onDismiss, onSubmit, type } = props;

    // Tag Type dropdown will be hidden if passed in via props
    const [ newTagType, setNewTagType ] = React.useState<number|undefined>(type as number);
    const [ newTagTooltip, setNewTagTooltip ] = React.useState<string|undefined>();

    const dismiss = React.useCallback(() => {
        if (onDismiss) {
            setNewTagType(undefined);
            setNewTagTooltip(undefined);
            onDismiss();
        }
    }, [onDismiss]);

    if (!tag) return null;

    return (
        <Dialog 
            hidden={false}
            dialogContentProps={{
                title: 'New Tag',
                showCloseButton: true,
            }}
            onDismiss={dismiss}
        >
            <form onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!Boolean(type || newTagType)) return;
                onSubmit({ Id: -1, Label: tag.Label, Tooltip: newTagTooltip, Type: newTagType } as Tag).then(dismiss);
            }}>
                <input type="submit" style={{visibility: "hidden", position: "absolute" }} />
                {!Boolean(type) && (
                    <Dropdown
                        disabled={Boolean(type)}
                        label="Type / Association"
                        options={[
                            {
                                key: 1,
                                text: 'User'
                            },
                            {
                                key: 2,
                                text: 'Desk'
                            },
                        ]}
                        selectedKey={type ? type : newTagType}
                        onChange={(e, opt) => {
                            setNewTagType(opt?.key as number);
                        }}
                        errorMessage={!Boolean(newTagType) ? 'Select a tag type' : undefined}
                    />
                )}
                <TextField
                    disabled={true}
                    label="Label"
                    value={tag.Label}
                />
                <TextField
                    autoFocus={true}
                    label="Hover Message / Tooltip"
                    value={newTagTooltip}
                    onChange={(e, newVal) => setNewTagTooltip(newVal)}
                    placeholder="Enter text to appear on hover"
                    errorMessage={!Boolean(newTagTooltip) ? 'Press Enter / Save for no tooltip' : undefined}
                />
                <DialogFooter>
                    <PrimaryButton 
                        disabled={!Boolean(type || newTagType)}
                        iconProps={{iconName: 'Save'}}
                        label="Save"
                        onClick={() => {
                            onSubmit({ Id: -1, Label: tag.Label, Tooltip: newTagTooltip, Type: newTagType } as Tag).then(dismiss);
                        }}
                    />
                </DialogFooter>
            </form>
        </Dialog>
    )
}